import React from 'react';
import Dropdown, { SearchInputProps, searchPrefix } from '../Basics/Dropdown';

const countryMap = require('../../../../shared/frontend/Countries.json') as Record<string, string>;

// semantic react ui does have these flags: https://react.semantic-ui.com/elements/flag/#types-flag
const noFlags = ['AQ', 'BQ', 'CW', 'GG', 'IM', 'JE', 'XK', 'BL', 'MF', 'SX', 'SS'];
const countriesOptions = Object.keys(countryMap)
  .map((key) => {
    return {
      flag: !noFlags.includes(key) ? key.toLowerCase() : undefined,
      value: key,
      text: countryMap[key],
      key,
    };
  })
  .sort((a, b) => a.text.localeCompare(b.text));

const CountryInput: React.FC<SearchInputProps> = ({ autoComplete, type, ...props }) => {
  return (
    <Dropdown
      placeholder='Choose Country'
      {...props}
      options={countriesOptions}
      search={searchPrefix}
      searchInput={{ autoComplete, type }}
    />
  );
};

export default CountryInput;
